var map = {
	"./vip_icon_1.webp": 3477,
	"./vip_icon_10.webp": 4139,
	"./vip_icon_2.webp": 2728,
	"./vip_icon_3.webp": 1899,
	"./vip_icon_4.webp": 3542,
	"./vip_icon_5.webp": 8273,
	"./vip_icon_6.webp": 932,
	"./vip_icon_7.webp": 2791,
	"./vip_icon_8.webp": 578,
	"./vip_icon_9.webp": 6989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9633;